import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface PolicyContent {
  title?: string;
  heading?: string;
  text?: string;
}

@Component({
  selector: 'app-deletion',
  templateUrl: './deletion.component.html',
  styleUrls: ['./deletion.component.scss']
})
export class DeletionComponent implements OnInit, OnDestroy {
  content: PolicyContent = {};
  private destroy$ = new Subject<void>();

  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
    this.loadContent();
    // Reload content when language changes
    this.translate.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.loadContent());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadContent(): void {
    this.translate.get('policies.dataDeletion')
      .pipe(takeUntil(this.destroy$))
      .subscribe(content => {
        this.content = content;
      });
  }

}
